import { createSlice } from '@reduxjs/toolkit';
import { ICreditCard } from '../../interfaces';
import { IFormControl } from '../../../../../ui/forms/interfaces';
import { createControl } from '../../../../../domain/validation/validation';
import { default as cloneDeep } from 'lodash/cloneDeep';

interface ISavedCreditCardsState{

    // BrigerPay credit card token of the saved card
    savedCreditCardToken: string;
    savedCreditCardEncryptedCvv: string;
    savedCreditCardKenticoItemID: number;
    savedCreditCardChecksum: string;

    savedCreditCards: ICreditCard[];

    cvvControl: IFormControl,
}

/**
 * initial state
 */
const initialState: ISavedCreditCardsState = {
    savedCreditCardToken: '',
    savedCreditCardEncryptedCvv: '',
    savedCreditCardKenticoItemID: 0,
    savedCreditCardChecksum: '',

    savedCreditCards: [],

    cvvControl: createControl('cvvControl', '', {
        required: true,
        int: true,
        maxlength: 4,
    }),
};

const savedCreditCardSlice = createSlice({
    name: 'saved-credit-card',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },

        setControl(state, action) {
            return {
                ...state,
                [action.payload.controlName]: cloneDeep(action.payload.control),
            }
        },
    }
});

export default savedCreditCardSlice;